export const getCardLogo = (cardType: string) => {
    let fileName = '';
    switch (cardType) {
        case "American Express":
            fileName = 'AmericanExpressLogo';
            break;
        case "Visa":
            fileName = 'VisaLogo';
            break;
        case "Master Card":
            fileName = 'MasterCardLogo';
            break;
        case "Discover":
            fileName = 'DiscoverLogo';
            break;
        default:
            fileName = cardType;
    }

    return `/media/${fileName}.svg`;
};
